<template>
    <nav class="w-full bg-white border-b shadow-sm border-gray-200 dark:bg-gray-800 dark:border-gray-700">
        <div class="px-3 py-3 lg:px-5 lg:pl-3">
            <div class="flex items-center justify-between">

                <div class="flex items-center">
                    <button data-drawer-target="logo-sidebar" data-drawer-toggle="logo-sidebar"
                        aria-controls="logo-sidebar" type="button"
                        class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
                        <span class="sr-only">Open sidebar</span>
                        <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg">
                            <path clip-rule="evenodd" fill-rule="evenodd"
                                d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z">
                            </path>
                        </svg>
                    </button>
                    <router-link :to="{name: 'dashboard.generalInventory.index'}" class="flex ml-8 md:mr-24">
                        <img src="@/assets/bdg_logistica_imagotipo.png" class="h-14 mr-3" alt="Bdg Logistica" />
                    </router-link>
                </div>

                <div class="flex items-center divide-x">
                    <div class="flex items-center px-6">
                        <p class="capitalize font-semibold text-gray-500">
                            {{ timestamp }}
                        </p>
                    </div>

                    <div v-if="employee" class="flex items-center px-3 h-14">
                        <NavbarSubsidiary />
                    </div>

                    <div class="flex items-center px-4 h-14">
                        <NavbarNotifications />
                    </div>
                    
                    <div class="flex items-center px-3">
                        <NavbarPrfileMenu />
                    </div>
                    
                </div>
                
            </div>
        </div>
    </nav>
</template>

<script>
    import NavbarSubsidiary from './NavbarSubsidiary.vue'
    import NavbarNotifications from './NavbarNotifications.vue'
    import NavbarPrfileMenu from './NavbarPrfileMenu.vue'
    import useAuth from '@/modules/auth/composables/useAuth'

    export default {
        components: {
            NavbarNotifications,
            NavbarPrfileMenu,
            NavbarSubsidiary
        },
        setup() {
            const { employee } = useAuth()
            return {
                employee
            }
        },
        data() {
            return {
                timestamp: ''
            }
        },
        methods: {
            getNow() {
                const options = {
                    weekday: "long",
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                    timeZone: "America/hermosillo",
                    hour12: true,
                    hour: "2-digit",
                    minute: "2-digit"
                };
                const today = new Date();
                this.timestamp = today.toLocaleTimeString('es-MX', options).replaceAll('de', '');
            }
        },
        mounted() {
            setInterval(() => {
                this.getNow()
            }, 100);
        }
    }
</script>